<button mat-raised-button *appRole="['TiposCondicionContable.Crear']" color="primary" [routerLink]="['/tiposcondicioncontable']">
  <mat-icon>add</mat-icon>
  Nuevo tipo de condición contable
</button>
